// extracted by mini-css-extract-plugin
module.exports = {"container":"MaxWidth_container__i2u3j","small":"MaxWidth_small__PmRBc","medium":"MaxWidth_medium__L__y0"};